import PropTypes from 'prop-types';
import React from 'react';
import HouseholdMembers from './components/HouseholdMembers';
import HouseholdMonthlyIncome from './components/HouseholdMonthlyIncome';
import MaritalInformation from './MaritalInformation';
var HouseholdInformation = function HouseholdInformation(_ref) {
  var contact = _ref.contact;
  return /*#__PURE__*/React.createElement("div", {
    className: "household-information row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/React.createElement("h3", null, "Household Information"), /*#__PURE__*/React.createElement(HouseholdMembers, {
    contact: contact
  }), /*#__PURE__*/React.createElement(MaritalInformation, {
    contact: contact
  }), /*#__PURE__*/React.createElement(HouseholdMonthlyIncome, {
    contact: contact
  })));
};
HouseholdInformation.propTypes = {
  contact: PropTypes.object.isRequired
};
export default HouseholdInformation;
//# sourceMappingURL=index.js.map